import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutsComponent } from './../shared/layouts/layouts.component';
import { ClientsComponent } from './clients/clients.component';
import { CountryComponent } from './country/country.component';
import { ZoneComponent } from './zone/zone.component';
import { StateComponent } from './state/state.component';
import { DistrictComponent } from './district/district.component';
import { LeadStatusComponent } from './lead-status/lead-status.component';
import { ProductCategoryComponent } from './product-category/product-category.component';
import { AuthGuard } from '../auth/guard/auth.guard';
import { LeadTypeComponent } from './lead-type/lead-type.component';
import { AgeGroupComponent } from './age-group/age-group.component';
import { RoleComponent } from './role/role.component';
import { LeadSourceComponent } from './lead-source/lead-source.component';
import { LeadStageComponent } from './lead-stage/lead-stage.component';
import { ProductColorComponent } from './product-color/product-color.component';
import { OccupationComponent } from './occupation/occupation.component';
import { CustomerTypeComponent } from './customer-type/customer-type.component';
import { FollowupReasonComponent } from './followup-reason/followup-reason.component';
import { JunkReasonComponent } from './junk-reason/junk-reason.component';
import { NoResponseReasonComponent } from './no-response-reason/no-response-reason.component';
import { VirtualNumberComponent } from './virtual-number/virtual-number.component';
import { PreSalesLostReasonComponent } from './pre-sales-lost-reason/pre-sales-lost-reason.component';
import { SalesLostReasonComponent } from './sales-lost-reason/sales-lost-reason.component';
import { ProductModelComponent } from './product-model/product-model.component';
import { ProductVarientComponent } from './product-varient/product-varient.component';
import { LeadSubSourceComponent } from './lead-sub-source/lead-sub-source.component';
import { LicenseCodeComponent } from './license-code/license-code.component';
import { AreaComponent } from './area/area.component';
import { RegionComponent } from './region/region.component';
import { ParentDealerComponent } from './parent-dealer/parent-dealer.component';
import { OutletComponent } from './outlet/outlet.component';
import { LocationComponent } from './location/location.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { LevelMasterComponent } from './level-master/level-master.component';
import { LikehoodToPurchaseMasterComponent } from './likehood-to-purchase-master/likehood-to-purchase-master.component';
import { CustomerRequirementComponent } from './customer-requirement/customer-requirement.component';
import { LeadPriorityComponent } from './lead-priority/lead-priority.component';
import { DeliveryPreferenceComponent } from './delivery-preference/delivery-preference.component';
import { PaymentMethodComponent } from './payment-method/payment-method.component';
import { CustomerInterestComponent } from './customer-interest/customer-interest.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { VNMappingComponent } from './vn-mapping/vn-mapping.component';
import { MsPinComponent } from './ms-pin/ms-pin.component';
import { CustomerTitleComponent } from './customer-title/customer-title.component';
import { ModeOfContactComponent } from './mode-of-contact/mode-of-contact.component';
import { SalesFollowReasonComponent } from './sales-follow-reason/sales-follow-reason.component';
import { PostponedReasonComponent } from './postponed-reason/postponed-reason.component';
import { FileTypeComponent } from './file-type/file-type.component';
import { ReportsComponent } from './reports/reports.component';
import { SubReasonComponent } from './sub-reason/sub-reason.component';
import { ProductLostReasonComponent } from './product-lost-reason/product-lost-reason.component';
import { ProductLostSubReasonComponent } from './product-lost-sub-reason/product-lost-sub-reason.component';
import { ServiceAdvisorComponent } from './service-advisor/service-advisor.component';
import { FollowUpStatusComponent } from './follow-up-status/follow-up-status.component';
import { LostModelComponent } from './lost-model/lost-model.component';
import { OemCompetitorComponent } from './oem-competitor/oem-competitor.component';
import { ChecklistComponent } from './checklist/checklist.component';
import { CustomerFeedbackComponent } from './customer-feedback/customer-feedback.component';
import { CorporateComponent } from './corporate/corporate.component';
import { CommunicateToComponent } from './communicate-to/communicate-to.component';
import { CustomerFollowupComponent } from './customer-followup/customer-followup.component';
import { CustomerCategoryComponent } from './customer-category/customer-category.component';
import { GenderComponent } from './gender/gender.component';
import { ImportUserComponent } from './import-user/import-user.component';
import { TermsComponent } from './terms/terms.component';
import { VnMappingImportComponent } from './vn-mapping-import/vn-mapping-import.component';
import { UsersComponent } from './users/users.component';
import { UsersUploadComponent } from './users-upload/users-upload.component';
import { NonSalesCategoryComponent } from './non-sales-category/non-sales-category.component';
import { PriceComponent } from './price/price.component';
const routes: Routes = [
  {
    path: '',
    component: LayoutsComponent,
    children: [
      { path: 'clients', component: ClientsComponent },
      { path: 'country', component: CountryComponent, canActivate: [AuthGuard]  },
      { path: 'zone', component: ZoneComponent, canActivate: [AuthGuard]  },
      { path: 'state', component: StateComponent, canActivate: [AuthGuard]  },
      { path: 'district', component: DistrictComponent, canActivate: [AuthGuard]  },
      { path: 'lead-status', component: LeadStatusComponent, canActivate: [AuthGuard] },
      { path: 'product-category', component: ProductCategoryComponent, canActivate: [AuthGuard] },
      { path: 'product-color', component: ProductColorComponent, canActivate: [AuthGuard] },
      { path: 'role', component: RoleComponent, canActivate: [AuthGuard] },
      { path: 'lead-type', component: LeadTypeComponent, canActivate: [AuthGuard] },
      { path: 'lead-source', component: LeadSourceComponent, canActivate: [AuthGuard] },
      { path: 'lead-stage', component: LeadStageComponent, canActivate: [AuthGuard] },
      { path: 'age-group', component: AgeGroupComponent, canActivate: [AuthGuard] },
      { path: 'occupation', component: OccupationComponent, canActivate: [AuthGuard] },
      { path: 'customer-type', component: CustomerTypeComponent, canActivate: [AuthGuard] },
      { path: 'follow-up-reason', component: FollowupReasonComponent, canActivate: [AuthGuard] },
      { path: 'junk-reason', component: JunkReasonComponent, canActivate: [AuthGuard] },
      { path: 'no-response-reason', component: NoResponseReasonComponent, canActivate: [AuthGuard] },
      { path: 'virtual-number', component: VirtualNumberComponent, canActivate: [AuthGuard] },
      { path: 'presales-lost-reason', component: PreSalesLostReasonComponent, canActivate: [AuthGuard] },
      { path: 'sales-lost-reason', component: SalesLostReasonComponent, canActivate: [AuthGuard] },
      { path: 'product-model', component: ProductModelComponent, canActivate: [AuthGuard] },
      { path: 'product-varient', component: ProductVarientComponent, canActivate: [AuthGuard] },
      { path: 'lead-subsource', component: LeadSubSourceComponent, canActivate: [AuthGuard] },
      { path: 'license-code', component: LicenseCodeComponent, canActivate: [AuthGuard] },
      { path: 'region', component: RegionComponent, canActivate: [AuthGuard] },
      { path: 'area', component: AreaComponent, canActivate: [AuthGuard] },
      { path: 'location', component: LocationComponent, canActivate: [AuthGuard] },
      { path: 'dealer', component: ParentDealerComponent, canActivate: [AuthGuard] },
      { path: 'outlet', component: OutletComponent, canActivate: [AuthGuard] },
      { path: 'change-password', component: ChangePasswordComponent, canActivate:[AuthGuard] },
      { path: 'user-profile', component: UserProfileComponent, canActivate:[AuthGuard] },
      { path: 'level-master', component:LevelMasterComponent, canActivate:[AuthGuard]},
      { path: 'likehood-purchase-master',component:LikehoodToPurchaseMasterComponent,canActivate:[AuthGuard]},
      { path: 'customer-requirement',component:CustomerRequirementComponent,canActivate:[AuthGuard]},
      { path: 'lead-priority',component:LeadPriorityComponent,canActivate:[AuthGuard]},
      { path:'delivery-preference',component:DeliveryPreferenceComponent,canActivate:[AuthGuard]},
      { path:'payment-method',component:PaymentMethodComponent,canActivate:[AuthGuard]},
      { path:'customer-interest',component:CustomerInterestComponent,canActivate:[AuthGuard]},
      { path: 'vn-mapping', component: VNMappingComponent, canActivate: [AuthGuard] },
      { path: 'ms-pin', component: MsPinComponent, canActivate: [AuthGuard] },
      { path: 'customer-title', component: CustomerTitleComponent, canActivate: [AuthGuard] },
      { path: 'mode-of-contact', component: ModeOfContactComponent, canActivate: [AuthGuard] },
      { path: 'sales-follow-reason', component: SalesFollowReasonComponent, canActivate: [AuthGuard] },
      { path: 'postponed-reason', component: PostponedReasonComponent, canActivate: [AuthGuard] },
      { path: 'file-type', component: FileTypeComponent, canActivate: [AuthGuard] },
      { path: 'reports', component: ReportsComponent, canActivate: [AuthGuard] },
      { path: 'sub-reason', component: SubReasonComponent, canActivate: [AuthGuard] },
      { path: 'product-lost-reason', component: ProductLostReasonComponent, canActivate: [AuthGuard] },
      { path: 'product-lost-sub-reason', component: ProductLostSubReasonComponent, canActivate: [AuthGuard] },
      { path: 'service-advisor', component: ServiceAdvisorComponent, canActivate: [AuthGuard] },
      { path: 'followup-status', component: FollowUpStatusComponent, canActivate: [AuthGuard] },
      { path: 'lost-model', component: LostModelComponent, canActivate: [AuthGuard] },
      { path: 'oem', component: OemCompetitorComponent, canActivate: [AuthGuard] },
      { path: 'checklist', component: ChecklistComponent, canActivate: [AuthGuard] },
      { path: 'customer-feedback', component: CustomerFeedbackComponent, canActivate: [AuthGuard] },
      { path: 'corporate', component: CorporateComponent, canActivate: [AuthGuard] },
      { path: 'communicate-to', component: CommunicateToComponent, canActivate: [AuthGuard] },
      { path: 'customer-followup', component: CustomerFollowupComponent, canActivate: [AuthGuard] },
      { path: 'customer-category', component: CustomerCategoryComponent, canActivate: [AuthGuard] },
      { path: 'gender', component: GenderComponent, canActivate: [AuthGuard] },
      { path: 'import', component: ImportUserComponent, canActivate: [AuthGuard] },
      { path: 'terms', component: TermsComponent, canActivate: [AuthGuard] },
      { path: 'vn-map-import', component: VnMappingImportComponent, canActivate: [AuthGuard] },
      { path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
      {
        path: "upload-users",
        component: UsersUploadComponent,
        canActivate: [AuthGuard],
      },
      { path: 'non-sales-category', component: NonSalesCategoryComponent, canActivate: [AuthGuard] },
      { path: 'price', component: PriceComponent, canActivate: [AuthGuard] },
      {
        path: '**', pathMatch: 'full',
        component: PageNotFoundComponent,  canActivate: [AuthGuard]
      },

    ],
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
